import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { TreeTable } from 'primeng/treetable';
import { ApiService } from "src/app/_services/api.service";
import { GlobalService } from "src/app/_services/global.service";
import { LanguageService } from 'src/app/_services/language.service';
import { ModelService } from '../../model/model.service';
import { ModelViewerComponent } from '../../model/model-viewer/model-viewer.component';
import { Table } from 'primeng/table';
import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import { saveAs } from 'file-saver';
import {formatDate} from '@angular/common';
import { Countries } from 'src/app/_helpers/countries';
import { v4 as uuidv4 } from 'uuid';
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import * as uuid from 'uuid';

import { even } from '@rxweb/reactive-form-validators';
import { DropindataService } from 'src/app/_services/dropindata.service';
import { FreeblocksdataService } from 'src/app/_services/freeblocksdata.service';
import { ScaffalidataService } from 'src/app/_services/scaffalidata.service';
import { ScaffaliminicelleService } from 'src/app/_services/scaffaliminicelle.service';
import { firstValueFrom } from 'rxjs';
require('jspdf-autotable');

function loadFile(url:any, callback:any) {
  PizZipUtils.getBinaryContent(url, callback);
}
 

@Component({
  selector: 'app-opportunity-edit',
  standalone: false,
  templateUrl: './opportunity-edit.component.html',
  styleUrl: './opportunity-edit.component.scss',
    providers: [MessageService,ConfirmationService]
})
export class OpportunityEditComponent implements OnInit {
  @ViewChild(ModelViewerComponent) viewer!: ModelViewerComponent;
  @ViewChild('dt') table!: Table;
  @ViewChild('divlatoporta') divlatoporta:any | undefined;
  @ViewChild('celladiv') celladiv:any | undefined;
  @ViewChild('modeldesign') modeldesign:any | undefined;

  

  @Input() public backUrl: string = '/opportunities';
  
  public countries: Countries = new Countries();
  showError:boolean=false;
  errorMessage:any[]=[];


  loadingDocs:boolean = true;
  langList:any[]=[
    {value:'it-IT',label:'Italian'},
    {value:'fr-FR',label:'French'},
    {value:'de-DE',label:'German'},
    {value:'en-UK',label:'English'},
    {value:'es-ES',label:'Spanish'}
  ];
  statusCellaOptions:any[]=[];
  riga:any={
    art_comp:'',
    des_comp:'',
    pzu_comp_uni:0,
    quantity:1
  };
  showDialogPrint:boolean=false;
  showDialogEleNonTrovati:boolean=false;
  showDialogAddComp:boolean=false;
  showDialogAddRiga:boolean=false;
  compSearchDesc:string='';
  gruppoDistintaList:any[]=[];
  gruppoDistinta:any=null;
  compSearchCode:string='';
  compToAdd:any=null;
  qtyToAdd:number=1;
  componentList:any[]=[];
  loadingComponentList:boolean=false;
  showDocs:boolean=false;
  tipoDocOptions:any[]=[];
  newDoc:any={
    id:null,
    tipo:'Offerta',
    descrizione:''
  };

  urlapi:string='';
  tipoStampa:string='pareti';
  tipodistampaList:any[]=[
    {
      label:'Tutto',
      value:'all'
    },
     {
      label:'Pareti',
      value:'pareti'
    },
     {
      label:'Pavimento',
      value:'pavimento'
    },
     {
      label:'Soffitto',
      value:'soffitto'
    }
  ];
  formatoStampa:string='a4';
  formatostampaList:any[]=[
    {
      label:'A4',
      value:'a4'
    },
    {
      label:'A3',
      value:'a3'
    },
    {
      label:'A2',
      value:'a2'
    },
    {
      label:'A1',
      value:'a1'
    },
    {
      label:'A0',
      value:'a0'
    },

    
  ];
  showCella:boolean=false;
  showEditor:boolean=false;
  doctemplatesList:any[]=[];
  cellaTitle:string='';
  showOpzioni:boolean=false;
  tabIndex:number=0;
  configurazioneCelle:any={};
  selectedCella:any=undefined;
  opzioniList:any[]=[];
  numopzioniList:any[]=[
    0,1,2,3,4,5,6,7,8,9,10
  ];
 
  itemsStampa:any[]=[];
  
  action:any='';
  cols:any[]=[];
  colsDistinta:any[]=[];
  docsList:any[]=[];
  prev:any={
    id:0,
    account_id:0,
    accountcountry:'',
    lang:'it-IT',
    name:'',
    exp_closing_date:new Date(),
    num_opp:'',
    note:'',
    status:'NUOVO',
    descrizioneTecnica:'',
    resa:'',
    tempoProduzione:'',
    validitaOfferta:'',
    condizioniPagamento:'',
    doctemplate:'',
    celle:[]
  };
   
  clientiList:any[]=[];

  statiprev:any[]=[
    'NUOVO','APERTO','ORDINE','INVIATO A BC','CHIUSO PERSO'
  ];
  numeroCelleOptions:number[]=[1,2,3,4,5,6,7,8,9,10];
  
  geometriaOptions=[
    {
      value:'RETTANGOLARI',
      label:'RETTANGOLARI'
    },
    {
      value:'COMPLESSI_CELLE',
      label:'COMPLESSI CELLE'
    }];


  
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
    private route: ActivatedRoute,
    public lang:LanguageService,
    public modelService:ModelService,
    private dropindataService:DropindataService,
    private freeblocksdataService:FreeblocksdataService,
    private scaffalidataService:ScaffalidataService,
    private scaffaliminicelleService:ScaffaliminicelleService
  ) { }

  ngOnInit(): void {  
    this.urlapi=this.globalService.endpoint+'app/doc_upload';
    this.tipoDocOptions=[
      {
        label:this.lang.el('Offerta'),
        value:'offerta'
      },
      {
        label:this.lang.el('Disegno pareti'),
        value:'pareti'
      },
      {
        label:this.lang.el('Disegno soffitto'),
        value:'soffitto'
      },
      {
        label:this.lang.el('Disegno pavimento'),
        value:'pavimento'
      },
      {
        label:this.lang.el('Disegno cella'),
        value:'all'
      },
      {
        label:this.lang.el('Altro'),
        value:'altro'
      },
    ];
    let usr=this.globalService.getUser();
    this.tipodistampaList=[
    {
      label:this.lang.el('Tutto'),
      value:'all'
    },
     {
      label:this.lang.el('Pareti'),
      value:'pareti'
    },
     {
      label:this.lang.el('Pavimento'),
      value:'pavimento'
    },
     {
      label:this.lang.el('Soffitto'),
      value:'soffitto'
    }
  ];
      

  this.modelService.divisorioPortaOptions=[
      {value:1,label:this.lang.el('Si')},
    ];
    this.modelService.pavimentoPortaOptions=[
      {value:1,label:this.lang.el('Si')},
      {value:0,label:this.lang.el('NO')}
    
    ];
    this.modelService.versoaperturaPortaOptions=[
      {value:1,label:this.lang.el('Dx')},
      {value:2,label:this.lang.el('Sx')}
    ];
  

  this.statiprev=[
    {
      value:'NUOVO',
      label:this.lang.el('NUOVO')
    },
    {
      value:'APERTO',
      label:this.lang.el('APERTO')
    },
    {
      value:'ORDINE',
      label:this.lang.el('ORDINE')
    },
    {
      value:'INVIATO A BC',
      label:this.lang.el('INVIATO A BC')
    },
    {
      value:'CHIUSO PERSO',
      label:this.lang.el('CHIUSO PERSO')
    },

  ]

  this.colsDistinta=[
            { field: 'codicePadre', header: this.lang.el('Codice padre')},   
            { field: 'art_comp', header: this.lang.el('Descrizione')},
            { field: 'des_comp',  header: this.lang.el('Codice')},
            { field: 'pzu_comp_uni',  header: this.lang.el('Prezzo unitario')},
            { field: 'quantity', header: this.lang.el('Quantità')},
            { field: 'pzu_comp', header: this.lang.el('Prezzo')},
            { field: 'new',  header: this.lang.el('Componente aggiunto')}
           
        ];
          
      
  this.geometriaOptions=[
    {
      value:'RETTANGOLARI',
      label:this.lang.el('RETTANGOLARI')
    },
    {
      value:'COMPLESSI_CELLE',
      label:this.lang.el('COMPLESSI CELLE')
    }];

  this.statusCellaOptions=[
    {
      value:'NUOVA',
      label:this.lang.el('NUOVA')
    },
    {
      value:'IN PROGETTAZIONE',
      label:this.lang.el('IN PROGETTAZIONE')
    },
    {
      value:'CONFERMATA',
      label:this.lang.el('CONFERMATA')
    }
  ];
/*
  if(this.isInvioBCEnabled()){
     this.statusCellaOptions.push({
      value:'INVIATA BC',
      label:this.lang.el('INVIATA BC')
     });
  }
*/
   // if(usr.organization=='ESTERNO'){
      this.modelService.tipo1PortaOptions=[
      {value:'MODULO',label:this.lang.el('MODULO')}
      ];
    //}
  //   if(usr.organization=='DAGARD' || usr.organization=='ESTERNO'){
    //   this.modelService.tipo1PortaOptions=[
    //   {value:'DAGARD',label:'MISTRAL'},
      // ];
  //   }
   this.modelService.tipo1PortaOptions.push({value:'DAGARD',label:this.lang.el('DAGARD')});
    this.modelService.tipo1PortaOptions.push({value:'SPORTELLI',label:this.lang.el('SPORTELLI')});
    

    this.modelService.divisorioCellaOptions=[
      {value:'normale',label:this.lang.el('Normale')},
      {value:'conPorta',label:this.lang.el('Con porta')},
      {value:'nessunDivisorio',label:this.lang.el('Nessun divisorio')},
    ];


    this.apiService.post('app/getopzionicella',{lang:this.lang.lang,logged_user_id:this.globalService.getUser().id}).subscribe(data2 => {
      this.opzioniList=data2;
      this.modelService.initCella(this.opzioniList,this.prev.lang,this.configurazioneCelle.electrolux);
      
    });
    
    this.apiService.post('app/opportunity_getcodiciportestrisceNew',{}).subscribe(data2 => {
      this.modelService.codiciPertendeAStrisce=data2.Result;
    });

    

    
    this.itemsStampa = [
            {
                label: this.lang.el('Tutto') ,
                command: () => {
                  this.printPdf('all');
                }
            },
            {
                label: this.lang.el('Pavimenti') ,
                command: () => {
                  this.printPdf('pavimento');
                }
            },
            {
                label: this.lang.el('Pareti'),
                command: () => {
                  this.printPdf('pareti');
                }
            },
            {
                label: this.lang.el('Soffitto'),
                command: () => {
                  this.printPdf('soffitto');
                }
            },
          ];
    this.action=this.route.snapshot.paramMap.get('action');
    this.apiService.post('app/accounts_listallDD',{logged_user_id:this.globalService.getUser().id}).subscribe(data2 => {
      this.clientiList=data2;
      if((this.action=='new') && (this.route.snapshot.paramMap.get('id'))){
        this.prev.account_id=this.route.snapshot.paramMap.get('id');
      }
      
    });

    
  
    if(this.action!='new' && this.route.snapshot.paramMap.get('id')){
        this.urlapi=this.globalService.endpoint+'app/doc_upload/'+this.route.snapshot.paramMap.get('id');
        this.apiService.post('app/opportunities_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
          this.prev=data2.Result[0];
       
          this.prev.celle=[...this.prev.celle];
          if(!this.prev.lang){
           this.prev.lang='it-IT';
          }
          let ll=this.prev.lang;
          if(ll=='en-UK'){
            this.prev.lang='en-EN';
           }
          this.apiService.post('app/doctemplates_listallDD',{lang:this.prev.lang,logged_user_id:this.globalService.getUser().id}).subscribe(data2 => {
            this.doctemplatesList=data2;
            
            this.loadDocs();

          });
         
        });
      } else {
          
      this.prev.lang=this.lang.lang;

      if(this.prev.lang=='it-IT'){
        this.prev.accountcountry='IT';
      }
      if(this.prev.lang=='fr-FR'){
        this.prev.accountcountry='FR';
      }
      if(this.prev.lang=='de-DE'){
        this.prev.accountcountry='DE';
      }
      if(this.prev.lang=='nl-NL'){
        this.prev.accountcountry='NL';
      }
      if(this.prev.lang=='es-ES'){
        this.prev.accountcountry='ES';
      }
      if(this.prev.lang=='pt-PT'){
        this.prev.accountcountry='PT';
      }
      if(this.prev.lang=='en-UK'){
        this.prev.accountcountry='EN';
      }
    
      this.apiService.post('app/doctemplates_listallDD',{lang:this.prev.lang,logged_user_id:this.globalService.getUser().id}).subscribe(data2 => {
        this.doctemplatesList=data2;
      });
        
    }
    if(this.isInvioBCEnabled()){
      this.cols=[ 
      {
        field: 'id',
        type:'edit',
        header: '', 
      },
      {
        field: 'status',
        type:'editstato',
        header: this.lang.el('Stato'), 
      },
       {
        field: 'rif_config',
        type:'field',
        header: this.lang.el('BC rif. config'), 
      },
      {
        field: 'descrizione',
        type:'field',
        header: this.lang.el('Descrizione'), 
      }, 
      {
        field: 'prezzolordo',
        type:'currency',
        header: this.lang.el('Prezzo listino'),  
      },
      {
        field: 'sconto',
        type:'editsconto',
        header: this.lang.el('Sconto %'), 
      },
      {
        field: 'prezzo',
        type:'currency',
        header: this.lang.el('Prezzo netto'), 
      },
      {
        field: 'id',
        type:'duplica',
        header: '', 
        pSortableColumnDisabled:true
      },
        {
        field: 'id',
        type:'delete',
        header: '', 
        pSortableColumnDisabled:true
      },
      
    ];

    } else {
      this.cols=[ 
        {
          field: 'id',
          type:'edit',
          header: '', 
        },
        {
          field: 'status',
          type:'editstato',
          header: this.lang.el('Stato'), 
        },
        {
          field: 'descrizione',
          type:'field',
          header: this.lang.el('Descrizione'), 
        }, 
        {
          field: 'prezzolordo',
          type:'currency',
          header: this.lang.el('Prezzo listino'),  
        },
        {
          field: 'sconto',
          type:'editsconto',
          header: this.lang.el('Sconto %'), 
        },
        {
          field: 'prezzo',
          type:'currency',
          header: this.lang.el('Prezzo netto'), 
        },
        {
          field: 'id',
          type:'duplica',
          header: '', 
          pSortableColumnDisabled:true
        },
          {
          field: 'id',
          type:'delete',
          header: '', 
          pSortableColumnDisabled:true
        },
        
      ];
    }

   // this.changeModelloPorta();
   
   
  }
      
  changeDistPorta(event:any,cellaDati:any,porta:any){
    porta.largDivlatoporta=this.divlatoporta!.nativeElement.offsetWidth;
    porta.leftDoorSpace=porta.distSnPorta;
   
    if(porta.lato_porta=='lato_fronte' || porta.lato_porta=='lato_retro'){
      porta.leftDoorSpacepx= Math.round(porta.distSnPorta*porta.largDivlatoporta/cellaDati.ingombroX)+'px'; 
    } else {
        porta.leftDoorSpacepx= Math.round(porta.distSnPorta*porta.largDivlatoporta/cellaDati.ingombroY)+'px'; 
    }
    
    let largportapx=parseInt(porta.doorSpacepx.replace('px',''));
    let leftDoorSpace=parseInt(porta.leftDoorSpacepx.replace('px',''));
    
    porta.rightDoorSpacepx= (porta.largDivlatoporta-leftDoorSpace-largportapx)+'px'; 
     if(porta.lato_porta=='lato_fronte' || porta.lato_porta=='lato_retro'){
      porta.rightDoorSpace=cellaDati.ingombroX-porta.larghporta-porta.distSnPorta;
    } else{
      porta.rightDoorSpace=cellaDati.ingombroY-porta.larghporta-porta.distSnPorta;
      
    }
  
    
    
  }

  getMarginLeftInCellaDiv(i:number){
    return (-8*(i+1)).toString()+'px';
  }

  getTopPositionInCellaDiv(porta:any,lato:string){
    
    let rightDoorSpace=parseInt(porta.rightDoorSpacepx.replace('px',''));
    if(this.celladiv && this.celladiv!.nativeElement.offsetHeight)
      return (rightDoorSpace/porta.largDivlatoporta*this.celladiv!.nativeElement.offsetHeight).toString()+'px';
    else 
      return '0px';
  }
  
  getLeftPositionInCellaDiv(porta:any,lato:string){
    if(this.celladiv){
  
      let leftDoorSpace=parseInt(porta.leftDoorSpacepx.replace('px',''));
      return (leftDoorSpace/porta.largDivlatoporta*this.celladiv!.nativeElement.offsetWidth).toString()+'px';
    } else {
      return'0px';
    }
  }
  

  getWidthInCellaDiv(porta:any,lato:string){
    if(lato=='lato_fronte' || lato=='lato_retro'){
      let largportapx=parseInt(porta.doorSpacepx.replace('px',''));
      if(this.celladiv)
        return (largportapx/porta.largDivlatoporta*this.celladiv!.nativeElement.offsetWidth-8).toString()+'px';
      else 
        return '0px';
    } else {
      let largportapx=parseInt(porta.doorSpacepx.replace('px',''));
      if(this.celladiv)
        return (largportapx/porta.largDivlatoporta*this.celladiv!.nativeElement.offsetHeight-8).toString()+'px';
      else 
        return '0px';
    }
    
  }
                                                                                      
  
  

  leftSpaceForDoor(cellaDati:any,lato:string,lporta:number){
    let dist=0;
    let pl=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta==lato);
    pl.forEach((p:any,ind:number)=>{
      if(ind<pl.length-1){
        dist+=p.doorSpace+p.distSnPorta;
      }
    });
    if(!cellaDati.ingombroX || cellaDati.ingombroX <=0){
      return -1;
    }
    if(!cellaDati.ingombroY || cellaDati.ingombroY <=0){
      return -1;
    }
    return dist;
    
    
    
  }
  canInsertDoor(cellaDati:any,lato:string){
    let caninsert=true;
     let pl=cellaDati.elencoPorte.filter((x:any)=>x.lato_porta==lato);
      pl.forEach((p:any)=>{
      if(p.modelloPorta==''){
        caninsert=false;
      }
    });
    return !caninsert;
  }
  selectModelloPorta(event:any,cellaDati:any,porta:any){
   
    let lporta=0;
    let latop=porta.lato_porta;
     porta.modelliPortaOptions.forEach((p:any)=>{
      if(p.value==porta.modelloPorta){
        lporta=p.lgz_pann;
        porta.luceNetta=p.luceNetta;
      }
    });
    
    porta.largDivlatoporta=this.divlatoporta!.nativeElement.offsetWidth;
    let initDisLeft=this.leftSpaceForDoor(cellaDati,latop,lporta);
    if(initDisLeft<0){
      porta.modelloPorta='';
      return;
    }
    porta.modelliPortaOptions.forEach((p:any)=>{
      if(p.value==porta.modelloPorta){
        lporta=p.lgz_pann;
        porta.doorSpace=lporta;
        porta.tipoApertura=p.TipoApertura;
        if(p.cod_comp.substring(p.cod_comp.length-1,1)=='S'){
          porta.scorrevole=true;
        } else {
          porta.scorrevole=false;
        }
     
      }
    });
    porta.larghporta=lporta;
    porta.eleDistOptions=[];  
    if(latop=='lato_sn' || latop=='lato_ds'){
      if(cellaDati.ingombroY && cellaDati.ingombroY >0){
        porta.doorSpacepx=Math.round(lporta*porta.largDivlatoporta/cellaDati.ingombroY)+'px';
        let step=initDisLeft;
        while(step+porta.larghporta<=cellaDati.ingombroY){
          porta.eleDistOptions.push(step);
          step+=20;
        }
      }
    }
    if(latop=='lato_fronte' || latop=='lato_retro'){
      if(cellaDati.ingombroX && cellaDati.ingombroX >0){
        porta.doorSpacepx=Math.round(lporta*porta.largDivlatoporta/cellaDati.ingombroX)+'px';
        let step=initDisLeft;
        while(step+porta.larghporta<=cellaDati.ingombroX){
          porta.eleDistOptions.push(step);
          step+=20;
        }
      }
    }
    if(porta.eleDistOptions.length==0){
      porta.modelloPorta='';
      porta.doorSpacepx=0;
      return;
    }
    porta.distSnPorta=porta.eleDistOptions[0];
    this.changeDistPorta(null,cellaDati,porta);
  }
  

  
  formIsValid(){
    return true;
  }
  

  save(){
    this.prev['logged_user_id']=this.globalService.getUser().id;

    this.apiService.post('app/opportunity_update',this.prev).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      
      if(this.action=='new'){
         this.router.navigateByUrl(this.backUrl+'/opportunity-edit/update/'+data[0].Result.id);
      } else {
         this.router.navigateByUrl(this.backUrl);
      }
     
    });
  }
  changeActive(record:any){
    if(!record.active){
      record.quantity=0;
      record.new='x';
    } else {
      record.new='';
      record.quantity=record.originalQuantity;
    }
     this.refreshDistinta();

  }
  saveCella(close=true,checkFormIsValid=true,salvaDistinta=true){

      if(checkFormIsValid && !this.checkFormIsValid()){
            return;
      }
      this.configurazioneCelle['logged_user_id']=this.globalService.getUser().id;
      this.configurazioneCelle.opp_id=this.prev.id;
      if(salvaDistinta && this.modelService.distintaData && this.modelService.distintaData.length>0){
           this.configurazioneCelle.distinta=this.modelService.distintaData;
      }
      this.apiService.post('app/opportunity_cella_update',this.configurazioneCelle).subscribe(data => {
      this.addSingle('success', 'Successo', 'Configurazione salvata ');
      this.apiService.post('app/opportunities_listall',{logged_user_id:this.globalService.getUser().id,id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
          this.prev=data2.Result[0];
          if(close){
            this.cellaTitle="";
            this.tabIndex=0;
            this.showCella=false;
          }
         
      });
    });
   
  }

  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  
  


  nuovaConfigurazione(){
    this.modelService.message='';
    this.modelService.distintaData=[];
    this.configurazioneCelle=this.modelService.initConfigurazione(this.opzioniList,this.prev.lang,false);
    this.cellaTitle=this.lang.el("Nuova configurazione");
    this.showCella=false;
    this.showEditor=true;
    setTimeout(()=>{
      this.tabIndex=4;
    },100);
    setTimeout(()=>{
    //  this.modeldesign.refreshNodes();
    },500);
   
  }
  invioBNConfirmed(){
    
   

    this.apiService.post('app/opportunity_inviaBC',this.prev).subscribe(data2 => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Invio a BC completato con successo'));
      setTimeout(() => {
  //       window.location.reload();
      }, 2000);
    });
  
  }

  invioBC(){

    this.confirmationService.confirm({
            message: this.lang.el('Attenzione tutte le configurazioni nello stato CONFERAMTA verranno inviate a Business Central. Si conferma?'),
            header: this.lang.el('Conferma'),
            closeOnEscape: true,
            icon: 'pi pi-exclamation-triangle',
            rejectLabel:this.lang.el('Annulla'),
            acceptLabel:this.lang.el('Conferma'),
            accept: () => {
             this.invioBNConfirmed();
            },
            reject: () => {
              
            },
    });
  }
  
  isInvioBCEnabled(){
    if(this.globalService.getUser().organization=='MISA' || this.globalService.getUser().role=='AMMINISTRATORE'){
      return true;
    } 
                               
    return false;
  }

  nuovoDisegno(what=''){
    if(this.showEditor){
     this.confirmationService.confirm({
          message: this.lang.el('Stai modificando una configurazione. Vuoi passare a questa configurazioen senza salvare?'),
          header: this.lang.el('Conferma'),
          closeOnEscape: true,
          icon: 'pi pi-exclamation-triangle',
          rejectLabel:this.lang.el('Annulla'),
          acceptLabel:this.lang.el('Conferma'),
          accept: () => {
            this.modelService.message='';
            this.modelService.distintaData=[];
            this.configurazioneCelle=this.modelService.initConfigurazione(this.opzioniList,this.prev.lang,what=='electrolux',false);
            this.cellaTitle=this.lang.el("Nuova configurazione");
            this.showCella=false;
            this.showEditor=true;
            
            setTimeout(()=>{
              this.tabIndex=4;
              
            },100);
            setTimeout(()=>{
              
              this.modeldesign.refreshNodes(true);
            },500);
          },
          reject: () => {
            
          },
      });

    } else {
      this.modelService.message='';
      this.modelService.distintaData=[];
      this.configurazioneCelle=this.modelService.initConfigurazione(this.opzioniList,this.prev.lang,what=='electrolux',false);
      this.cellaTitle=this.lang.el("Nuova configurazione");
      this.showCella=false;
      this.showEditor=true;
      
      setTimeout(()=>{
        this.tabIndex=4;
        
      },100);
      setTimeout(()=>{
        this.modeldesign.refreshNodes();
      },500);
    
    }
    
    
  }
  
  checkFormIsValid(){

    this.errorMessage=this.modelService.formCellaIsValid(this.configurazioneCelle);
    if(this.errorMessage.length>0){
      this.showError=true;
      return false;
    }
    return true;
  }

  getVolume(cella:any){
    if(cella.ingombroX && cella.ingombroY && cella.altezza){
      return (Math.round(cella.ingombroX*cella.ingombroY*cella.altezza/1000000 * 100) / 100).toFixed(2);
    } else {
      return 0;
    }

  }
  goEditCella(record:any){
    this.modelService.operazioneInCorso=true;
    this.showCella=true;
    this.showEditor=true;
    this.cellaTitle=this.lang.el("Modifica configurazione");
    this.modelService.distintaData=[];
   
    if(record.distinta && typeof record.distinta === 'string' && record.distinta!='' && record.distinta!='null'){
      this.modelService.distintaData=JSON.parse(record.distinta);
      this.setActiveDistintaData();
    } else {
      this.modelService.distintaData=[];
    }
    this.configurazioneCelle=record;
    if (typeof record.elencoCelle === 'string' || record.elencoCelle instanceof String){
      this.configurazioneCelle.elencoFreeBlocks=JSON.parse(record.elencoFreeBlocks);
      this.configurazioneCelle.elencoImpiantiRemoti=JSON.parse(record.elencoImpiantiRemoti);
      this.configurazioneCelle.elencoDropin=JSON.parse(record.elencoDropin);
      this.configurazioneCelle.elencoScaffali=JSON.parse(record.elencoScaffali);
      this.configurazioneCelle.elencoCelle=JSON.parse(record.elencoCelle);
      if(record.elencoPunti){
        this.configurazioneCelle.elencoPunti=JSON.parse(record.elencoPunti);
      }
      
      this.configurazioneCelle.elencoPorteScollegate=JSON.parse(record.elencoPorteScollegate);
      this.modelService.getCompatibilitbyCelle(this.configurazioneCelle,this.opzioniList,this.prev.lang,this.prev.electrolux);
    } 
    if(!this.configurazioneCelle.elencoPorteScollegate){
      this.configurazioneCelle.elencoPorteScollegate=[];
    }
    
    if(!this.configurazioneCelle.elencoFreeBlocks){
      this.configurazioneCelle.elencoFreeBlocks=[];
    }
    if(!this.configurazioneCelle.elencoImpiantiRemoti){
      this.configurazioneCelle.elencoImpiantiRemoti=[];
    }
    if(!this.configurazioneCelle.elencoDropin){
      this.configurazioneCelle.elencoDropin=[];
    }
    if(!this.configurazioneCelle.elencoScaffali){
      this.configurazioneCelle.elencoScaffali=[];
    }
    if(!this.configurazioneCelle.elencoCelle){
      this.configurazioneCelle.elencoCelle=[];
    }
    if(!this.configurazioneCelle.elencoPunti){
      this.configurazioneCelle.elencoPunti=[];
    }
    
    

    this.changePrezzo(this.configurazioneCelle);
    this.modelService.message='';


    if(!this.configurazioneCelle.diagram){

      this.drawCella(false);
      this.modelService.message='';
      this.cellaTitle=this.lang.el("Modifica configurazione");
      setTimeout(()=>{
           this.tabIndex=4;
      },3000);
    } else {
      setTimeout(()=>{
        this.tabIndex=4;
      },100);
             

      setTimeout(()=>{
        this.modeldesign.refreshNodes();
        this.modelService.operazioneInCorso=false;
      },500);
    }
   
  }
  editCella(record:any){
    if(!this.showEditor){
       this.goEditCella(record);
    } else {
      this.confirmationService.confirm({
          message: this.lang.el('Stai modificando una configurazione. Vuoi passare a questa configurazioen senza salvare?'),
          header: this.lang.el('Conferma'),
          closeOnEscape: true,
          icon: 'pi pi-exclamation-triangle',
          rejectLabel:this.lang.el('Annulla'),
          acceptLabel:this.lang.el('Conferma'),
          accept: () => {
            this.goEditCella(record);
          },
          reject: () => {
            
          },
      });
 
    }
   
  }

  deleteCella(record:any){
    this.confirmationService.confirm({
        message: this.lang.el('Si conferma la cancellazione della configurazione?'),
        header: this.lang.el('Conferma'),
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:this.lang.el('Annulla'),
        acceptLabel:this.lang.el('Conferma'),
        accept: () => {
      
          this.apiService.post('app/opportunity_cella_delete',{id:record.id}).subscribe(data2 => {
            this.messageService.add({ severity: 'warning', summary:  this.lang.el('Eliminato'), 
              detail:  this.lang.el('Record cancellato') });
            this.prev.celle = this.prev.celle .filter((item:any) => item.id !== record.id);
         
          });
          
        },
        reject: () => {
           
        },
    });
 

    
  }

  showDistinta(){
   
  }
  calcTotalGroup(codicePadre:any){
    let tot=0;
    this.modelService.distintaData.filter((x:any)=> x.codicePadre==codicePadre).forEach((c:any)=>{
      tot+= parseFloat(c.pzu_comp);
    })
    return tot; 
  }

  pushOrAdd(ele:any,codice:string,qty:number,codiceCappello=null){
    let isPres=false;
    ele.forEach((z:any,ind:number)=>{
      if(z.art_comp==codice){
        isPres=true;
        ele[ind].qty+=qty;
      }
    });
    if(!isPres){
      if(codiceCappello){
        ele.push({
          art_comp:codice,
          qty:qty,
          codiceCappello:codiceCappello
        });
      } else{
        ele.push({
          art_comp:codice,
          qty:qty
        });
      }
    
    } 
  }

  drawCellabtn(){
   if(!this.checkFormIsValid()){
      return;
    } 
       
    this.drawCella();
  }

  drawCella(calcDistinta=true, afterDistinta: (() => void) | null = null){
    
    let allCodici:any={
      celle:[],
      scaffali:[],
      impianti:[],
      impiantiTipi:[],
      dropin:[],
      freeblocks:[],
      minicelle:[],
      porteScollegate:[],
      porteScollegateConf:[],
      tipoPorteScollegateConf:[],
    };
     this.showCella=true;
    setTimeout(()=>{
        allCodici.celle=this.viewer.drawConfigurazione();
        if(!calcDistinta){
          if (afterDistinta) {
            afterDistinta();
          }
          return;
        }
      setTimeout(()=>{
        let porteScollegateAll:any=[];
        this.configurazioneCelle.elencoPorteScollegate.forEach((p:any,ind:number)=>{
          if(p.strisceporta){
            let codice='';
            let portaLabel=p.modelliPortaOptions.filter((m:any)=> m.value==p.modelloPorta)[0].luceNetta;
            this.modelService.codiciPertendeAStrisce.forEach((m:any)=>{
              
                if(portaLabel.indexOf(m.luce_netta)>=0){
                  codice=m.nr;
                }
             
            });
          
            this.pushOrAdd(allCodici.porteScollegate,codice,1);
          }
          if(p.configurata){
           
            allCodici.tipoPorteScollegateConf.push({
              tipoPorteConf:p.tipologiaPorta
            });
            
            this.setCodiciPortePreconfigurate(p.pavimenti,p.altezza,p.spessore,p,allCodici.porteScollegateConf[allCodici.porteScollegateConf.length-1]);
          } else {
            this.pushOrAdd(allCodici.porteScollegate,p.modelloPorta,1);
          }
        });
        

        this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
          
       

          if(c.isMiniCella){
            let codiceScaffale='';
            if(c.minicellaScaffale && c.minicellaScaffale!=''){
              let filtro=c.ingombroX/10+'-'+c.ingombroY/10;
              let filtrominic=this.scaffaliminicelleService.getData().filter((x:any)=> x.MINI_CELLA==filtro);
              if(filtrominic.length>0){
                if(c.minicellaScaffale=='3 ripiani'){
                  codiceScaffale=filtrominic[0].CODICE_3_RIPIANI;
                }
                if(c.minicellaScaffale=='4 ripiani'){
                  codiceScaffale=filtrominic[0].CODICE_4_RIPIANI;
                }
              }
            }
            allCodici.minicelle.push({
              altezza:c.altezza,
              lunghezza:c.ingombroX/10,
              larghezza:c.ingombroY/10,
              customClient:c.customClient,
              spessore:c.spessore,
              codiceScaffale:codiceScaffale,
              minicellaImpianto:c.minicellaImpianto,
              pavimento:c.pavimenti,
              porta:c.elencoPorte.length>0 ?c.elencoPorte[0].versoAperturaPorta :-1
            });
          }

        });
 
// SCAFFALI        
// aggiunge i codici per i SCAFFALI
        this.configurazioneCelle.elencoScaffali.forEach((scaffale:any,ind:number)=>{
          let scaffaliAll:any=[];
          if(false && scaffale.elenco.length==1 && scaffale.elenco[0].qty==1){
            scaffale.elenco.forEach((sc:any,ind:number)=>{
              this.pushOrAdd(scaffaliAll,sc.scaffale.CODICERIPIANO,scaffale.numeroRipiani);
              if(scaffale.scaffaliUniti){
                if(sc.scaffale.Profondita==37){
                  this.pushOrAdd(scaffaliAll,'CKOAG37C',scaffale.numeroRipiani);
                }
                if(sc.scaffale.Profondita==47){
                  this.pushOrAdd(scaffaliAll,'CKOAG47C',scaffale.numeroRipiani);
                }
                if(sc.scaffale.Profondita==56){
                  this.pushOrAdd(scaffaliAll,'CKOAG56GC',scaffale.numeroRipiani);
                }
                
                this.pushOrAdd(scaffaliAll,sc.scaffale.CODICESPALLA,1);
              } else {
                this.pushOrAdd(scaffaliAll,sc.scaffale.CODICESPALLA,2);
              }
              
            });
          }else{
          
            scaffale.elenco.forEach((sc:any,ind:number)=>{
              this.pushOrAdd(scaffaliAll,sc.scaffale.CODICERIPIANO,scaffale.numeroRipiani*sc.qty);
             // this.pushOrAdd(scaffaliAll,sc.scaffale.CODICESPALLA,sc.qty);
              
           
              //if(ind==scaffale.elenco.length-1 && scaffale.elenco.length>1){
                if(scaffale.scaffaliUniti && ind==0){
                  if(sc.scaffale.Profondita==37){
                    this.pushOrAdd(scaffaliAll,'CKOAG37C',scaffale.numeroRipiani);
                  }
                  if(sc.scaffale.Profondita==47){
                    this.pushOrAdd(scaffaliAll,'CKOAG47C',scaffale.numeroRipiani);
                  }
                  if(sc.scaffale.Profondita==56){
                    this.pushOrAdd(scaffaliAll,'CKOAG56GC',scaffale.numeroRipiani);
                  }
                  
                //  this.pushOrAdd(scaffaliAll,sc.scaffale.CODICESPALLA,sc.qty);
                } else {
                if(ind==0){
                      this.pushOrAdd(scaffaliAll,sc.scaffale.CODICESPALLA,1);
                  }
                }
                  this.pushOrAdd(scaffaliAll,sc.scaffale.CODICESPALLA,sc.qty);
           //   }
            });
          }

        

          allCodici.scaffali.push(scaffaliAll);    
        });
        

 // aggiunge i codici per i DROPIN
       
        let dropinData=this.dropindataService.getData();
        this.configurazioneCelle.elencoDropin.forEach((dropin:any,ind:number)=>{
          let dropinAll:any=[];
          let dropinFilter=dropinData.filter((x:any)=>
           x.art_comp==dropin.art_comp);
          if(dropinFilter.length>0){
            let hasAcc=false;
            let acc:any=[];
            let codice=dropinFilter[0].art_comp;
          
            if(dropin.accessorio_bacinella_acqua){
              codice+="A";
              hasAcc=true;
              acc.push(dropinFilter[0].accessorio_bacinella_acqua);  
            }
            if(dropin.accessorio_bus_adapter){
              if(!hasAcc){
                  codice+="A";
              }
              hasAcc=true;
              acc.push(dropinFilter[0].accessorio_bus_adapter);
            }
            this.pushOrAdd(dropinAll,codice,1);
            codice=codice.substring(1);
            if(!hasAcc){
              this.pushOrAdd(dropinAll,codice,1);
            } else {
              codice=codice.substring(0, codice.length - 1);
              this.pushOrAdd(dropinAll,codice,1);
            }
             acc.forEach((a:any)=>{
                this.pushOrAdd(dropinAll,a,1);
            }); 
          }
          allCodici.dropin.push(dropinAll);
        });
      
        
 // aggiunge i codici per i FREEBLOCKS
        
        let freeBData=this.freeblocksdataService.getData();
        let freeBDataUniversal=this.freeblocksdataService.getDataUniversal();
        if(this.prev.electrolux==1){
          freeBData = freeBData.filter((x:any)=> this.modelService.freeBlockElectrolux.includes(x.art_comp));
        } else {
          freeBData = freeBData.filter((x:any)=> !this.modelService.freeBlockElectrolux.includes(x.art_comp));
        }
        this.configurazioneCelle.elencoFreeBlocks.forEach((fb:any,ind:number)=>{
          let freeAll:any=[];
          let freeBFilter:any=freeBData.filter((x:any)=>x.art_comp==fb.art_comp);
          if(fb.subType){
            freeBFilter=freeBDataUniversal.filter((x:any)=>x.art_comp==fb.art_comp);
          }
          if(freeBFilter.length>0){
            let hasAcc=false;
            let acc:any=[];
            let codice=freeBFilter[0].art_comp;
            if(fb.accessorio_bacinella_acqua){
              codice+=codice.substring(0,2)=="XC" ? "":"A";
              hasAcc=true;
              acc.push(freeBFilter[0].accessorio_bacinella_acqua);
           
            }
            if(fb.accessorio_bus_adapter){
              if(!hasAcc){
                  codice+=codice.substring(0,2)=="XC" ? "":"A";;
              }         
              hasAcc=true;
              acc.push(freeBFilter[0].accessorio_bus_adapter);
          
            }
            if(fb.accessorio_resistenza_carter){
              if(!hasAcc){
                  codice+=codice.substring(0,2)=="XC" ? "":"A";;
              }
              hasAcc=true;
              acc.push(freeBFilter[0].accessorio_resistenza_carter);
            }
            this.pushOrAdd(freeAll,codice,1);
            
            if(!hasAcc){
              codice=codice.substring(1);
              this.pushOrAdd(freeAll,codice,1);
            } else {
              if(codice.substring(0,2)!="XC"){
                codice=codice.substring(1);
                codice= codice.substring(0, codice.length - 1);
              } else {
                codice=codice.substring(1);
              }
             
              this.pushOrAdd(freeAll,codice,1);
            }
            acc.forEach((a:any)=>{
                this.pushOrAdd(freeAll,a,1);
            });
          }
          allCodici.freeblocks.push(freeAll);
        });
      
// aggiunge i dati per gli impianti
    

        this.configurazioneCelle.elencoImpiantiRemoti.forEach((ir:any,ind:number)=>{
          let impiantiAll:any=[];

          let tempInt=ir.tempInt;
          let tempEst=ir.tempEst;
          let volume=ir.volume;  
          let irData=this.modelService.irData[ir.type].filter((x:any)=>
               x.IdTemperaturaInterna==tempInt && x.IdTemperaturaEsterna==tempEst);
          let cIt:any={
            art_comp:ir.art_comp,
            tipoImpianto:ir.tipoImpianto,
            volume:ir.volume
          };
          irData.forEach((impiantocorrente:any)=>{
           
            if( impiantocorrente.art_comp==cIt.art_comp  ){
              if(ir.type=='MS' || ir.type=='MSG' || ir.type=='MISAERM' ){
                if(ir.opzioni.length>0){
                  this.pushOrAdd(impiantiAll,cIt.art_comp.substring(1),1);
                  this.pushOrAdd(impiantiAll,cIt.art_comp+"A",1);            
                } else {
                  this.pushOrAdd(impiantiAll,cIt.art_comp,1);                
                }
              } else {
                if(impiantocorrente.art_comp_nipote && impiantocorrente.art_comp_nipote!=''){
                  this.pushOrAdd(impiantiAll,impiantocorrente.art_comp_nipote,1,cIt.art_comp); 
                }
                
                if(impiantocorrente.art_comp_figlio && impiantocorrente.art_comp_figlio!=''){
                  this.pushOrAdd(impiantiAll,impiantocorrente.art_comp_figlio,1,cIt.art_comp); 
                }
              }
              // MANDATORY
              let mandatory= this.modelService.impiantoRemotoOpzioniData.opzioni.filter((x:any)=>
                  x[cIt.tipoImpianto]=='X' && (x.STANDARD=='C' || x.STANDARD=='M')
                );
                
              // prende tutti i mandatory con 1 sola scelta
              mandatory.forEach((opt:any,ind:number)=>{ 
                if(mandatory.filter((m:any)=> m.CHAPTER==opt.CHAPTER).length==1){
                  let isCompatible=true;
                  ir.mandatory.forEach((m:any)=>{
                   let mm:any=this.modelService.impiantoRemotoOpzioniData.opzioni.filter((x:any)=> x.codComp==m)[0];
                   if((mm.nonCompatibileCon && mm.nonCompatibileCon.indexOf(opt.CHAPTER)>=0)){
                    isCompatible=false;
                   }
                  });
                  if(isCompatible){
                                   

                    if(ir.type=='MS' || ir.type=='MSG' || ir.type=='MISAERM' ){
                      this.pushOrAdd(impiantiAll,opt.codComp,1);
                    } else {
                      this.pushOrAdd(impiantiAll,opt.codComp,1,cIt.art_comp);
                    }
                  }
              
                }
              });
           
              // OPZIONI
              ir.opzioni.filter((x:string)=>x!='').forEach((opt:any,ind:number)=>{
                  let qty=1;
                  if(opt==ir.valueSetTubi){
                    qty=ir.numerotubi;
                  }
                  if(ir.type=='MS' || ir.type=='MSG' || ir.type=='MISAERM' ){
                      this.pushOrAdd(impiantiAll,opt,qty);
                  } else {
                      this.pushOrAdd(impiantiAll,opt,qty,cIt.art_comp);
                  }
              });
              ir.mandatory.forEach((opt:any,ind:number)=>{
                  if(ir.type=='MS' || ir.type=='MSG' || ir.type=='MISAERM' ){
                      this.pushOrAdd(impiantiAll,opt,1);
                  } else {

                      this.pushOrAdd(impiantiAll,opt,1,cIt.art_comp);
                  }
                
              });
             

            }
          });
    
          allCodici.impianti.push(impiantiAll);
          allCodici.impiantiTipi.push(ir.type);
        });
 
// aggiunge i dati per le PORTE CONFIGURATE
        let celleDagardPreConf:any={};
        let cellaPreCOnfigurata=false;
       
        this.configurazioneCelle.elencoCelle.forEach( (c:any,indCella:number)=>{
          celleDagardPreConf.altezza=c.altezza;
          celleDagardPreConf.ingombroX=c.ingombroX;
          celleDagardPreConf.ingombroY=c.ingombroY;
          celleDagardPreConf.spessore=c.spessore;
        
          celleDagardPreConf.vespaio=this.modelService.currVespaio;
          celleDagardPreConf.pavimento=c.pavimenti;
          if(c.valvolaCompensazione){
            let volume=0;
            let codice='';
            let qty=1;
            if(c.ingombroX && c.ingombroY && c.altezza){
              volume= Math.round(c.ingombroX*c.ingombroY*c.altezza/1000000 * 100) / 100;
            }
            if(c.spessore==10 || c.spessore==13 ){
                if(volume>75){
                  qty=2;
                }
                codice='M2157931';
                
            } else {
              if(volume>75){
                  qty=2;
              }
              codice='M2157932';
            }
            celleDagardPreConf.valvolaCompensazione=[{codice:codice,qty:qty}];
          }
          celleDagardPreConf.porta={};
          if(c.isCellaPreConf){
            cellaPreCOnfigurata=true;
            allCodici.scaffali=[];
          }
      
          c.elencoPorte.forEach( (p:any,ind:number)=>{
            celleDagardPreConf.porta.modelloPorta=p.modelloPorta;
            if(p.configurata){
            //  allCodici.celle.codiciPorteConf[indCella].push([]);
              allCodici.celle.tipoPorteConf[indCella].push({
                tipologiaPorta:p.tipologiaPorta
              });
              let codipt:any=[];
              this.setCodiciPortePreconfigurate(c.pavimenti,c.altezza,c.spessore,p,codipt);
              allCodici.celle.codiciPorteConf[indCella].push(codipt);
            }
          
          });
        });

        if(this.modelService.isCustomDistinta()){
          // distinta custom: non ricalcolare da BC, ma il salvataggio può comunque procedere
          if (afterDistinta) {
            afterDistinta();
          }
          return;
        }
        let param:any={configurazione:allCodici};
         param.isDagard=false;
        if(window.location.hostname.indexOf('dagard')>=0){
          param.isDagard=true;
        }
       
        if(this.modelService.userCellePreConf() || cellaPreCOnfigurata){
           this.configurazioneCelle.elencoCelle.forEach( (c:any)=>{
            if(c.scaffaliCellePreconfCodice!=''){
              let scaff:any={};
              let label='';
              let confL=this.modelService.scaffaliPreCof_L.filter((s:any)=> s.codice==c.scaffaliCellePreconfCodice);
              if(confL.length>0){
                scaff=confL[0];
                label=scaff.ripiani+' '+this.lang.el('ripiani')+' '+scaff.prof+' '+this.lang.el('profondita')+' '+this.lang.el('In linea')
              } else {
                let confLU=this.modelService.scaffaliPreCof_LU.filter((s:any)=> s.codice==c.scaffaliCellePreconfCodice);
                scaff=confLU[0];
                if(scaff.tipo=='L'){
                    label=scaff.ripiani+' '+this.lang.el('ripiani')+' '+this.lang.el('a L')
                }
                if(scaff.tipo=='U'){
                    label=scaff.ripiani+' '+this.lang.el('ripiani')+' '+this.lang.el('a U')
                }
              }
              if(scaff){
                scaff.desc=label;
                celleDagardPreConf.scaffailiPreConf=scaff;
              }
            }
           });
          
        }
        if(this.modelService.userCellePreConf() || cellaPreCOnfigurata){
          param.celleDagardPreConf=celleDagardPreConf;
        }
         
           
        this.modelService.message='';

        this.apiService.post('app/opportunity_getdistintaBC',param).subscribe({
          next: (data2) => {
          this.modelService.distintaData=data2.Result['distinta'];
          this.setActiveDistintaData();
          this.modelService.distintaData=[...this.modelService.distintaData];
          let tot=0;
          let prezzoDagard=0;
          this.modelService.distintaData.forEach((c:any)=>{
            tot+=parseFloat(c.pzu_comp);
            if(c.codicePadre.indexOf('MISTRAL')>=0){
              prezzoDagard+=c.pzu_comp;
            }
          });
          this.configurazioneCelle.prezzolordo=prezzoDagard>0 ? prezzoDagard: tot;;
          this.changePrezzo(this.configurazioneCelle);
          if(this.modeldesign.listini.totIterazioni==0 && data2.Result.notFound && data2.Result.notFound.length>0){
            this.modelService.message='';
            data2.Result.notFound.forEach((x:any)=>{
              this.modelService.message+=' '+x;
            });
            this.showDialogEleNonTrovati=true;
          }
          this.aggiornaDistinta(true);
          if(this.modeldesign.listini.totIterazioni>0){
           
            let volume=(3+this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].ingombroX)*(3+this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].ingombroY);
            volume*=(3+this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].altezza)/1000000;
            
            let prezzo:any={
                altezza:this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].altezza,
                dimensioni:this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].ingombroX+'x'+this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].ingombroY,
                volume:volume,
                prezzoConPavimenti:0,
                prezzoSenzaPavimenti:0,
                costoConPavimenti:0,
                costoSenzaPavimenti:0,
                notFound:data2.Result.notFound
            };
            let totCosto=0;
            this.modelService.distintaData.forEach((d:any)=>{
                totCosto+=d.pzu_costo*(d.quantity?d.quantity:0);
            });
            if(this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].pavimenti){
              prezzo.costoConPavimenti= totCosto;
              prezzo.prezzoConPavimenti= this.configurazioneCelle.prezzo;
            } else {
              prezzo.costoSenzaPavimenti= totCosto;
              prezzo.prezzoSenzaPavimenti= this.configurazioneCelle.prezzo;
            }

            let isPresent=false;
            this.modeldesign.listini.prezzi.forEach((p:any,ind:number)=>{
              if(p.altezza==prezzo.altezza && p.dimensioni==prezzo.dimensioni && p.volume==prezzo.volume){
                if(this.configurazioneCelle.elencoCelle[this.modelService.currCellaInd].pavimenti){
                  this.modeldesign.listini.prezzi[ind].prezzoConPavimenti= this.configurazioneCelle.prezzo;
                  this.modeldesign.listini.prezzi[ind].costoConPavimenti= totCosto;
                } else {
                  this.modeldesign.listini.prezzi[ind].prezzoSenzaPavimenti= this.configurazioneCelle.prezzo;
                  this.modeldesign.listini.prezzi[ind].costoSenzaPavimenti= totCosto;
                }
               isPresent=true;
              }
            });
            if(!isPresent){
               this.modeldesign.listini.prezzi.push(prezzo);
            }
           
            this.modeldesign.listini.distinte.push(this.modelService.distintaData);
            this.modeldesign.stepCompletatoCreazioneListini();
          }
          // distinta completa (+ opzioni): solo ora il salvataggio può procedere in modo coerente
          if (afterDistinta) {
            afterDistinta();
          }
          },
          error: () => {
            this.modelService.isSaving = false;
            this.addSingle('error', this.lang.el('Errore'), this.lang.el('Aggiornamento distinta non riuscito: salvataggio annullato'));
          }
        });
      },1000);
    },1000);
     

  }

  setActiveDistintaData(){
    this.modelService.distintaData.forEach((m:any,ind:number)=>{
     if(!m.hasOwnProperty('active')){
      this.modelService.distintaData[ind].active=true;
      this.modelService.distintaData[ind].originalQuantity=this.modelService.distintaData[ind].quantity;
     }
    }); 
    this.modelService.distintaData=[...this.modelService.distintaData];
    this.refreshDistinta();
  }

  setCodiciPortePreconfigurate(pavimenti:boolean,altezzaCella:number,spessoreCella:number,p:any,allCodici:any){
    if(p.configurata){

              // OPZ PORTA PARICELLA
              if(altezzaCella==p.altezza && (p.tipologiaPorta=='INDUSTRIALI BATTENTE' || p.tipologiaPorta=='INDUSTRIALI SCORREVOLI') ){
                   allCodici.push({
                    art_comp:'M2054800',
                    qty:1});
              }
              
                
              let cat1=['IP10','IP12','IP14','IP16','IN10','IN12','IN14','IN16','IPG12'];
              let cat2=['IPS10','IPS12','IPS14','IPS16','IPS20','IPS24','INS10','INS12','INS14','INS16','INS20','INS24','IPSG 12'];
              if(p.porte && p.porte[0] && p.porte[0].cat && cat1.includes(p.porte[0].cat)){
                  allCodici.push({
                    art_comp:'M2054531',
                    qty:1});
              }
               if(p.porte && p.porte[0] && p.porte[0].cat && cat2.includes(p.porte[0].cat)){
                  allCodici.push({
                    art_comp:'M2054532',
                    qty:1});
              }


              // FITTIZIO PER CAPIRE LO SPESSORE
              if(p.spessore){
                  this.pushOrAdd(allCodici,"SPESSORE_"+p.spessore,1);
              }
              
              // MANDATORY SCELTE
              p.configurataMandatory.filter((x:any)=> x!=null).forEach((opt:any)=>{
                  allCodici.push({
                    art_comp:opt,
                    qty:1});
              });
              // OPZIONI SCELTE
              let misuraLarg=false;
              let misuraAlt=false;
              p.configurataOpzioni.filter((x:any)=> x!=null).forEach((opt:any)=>{
                if(opt !== undefined){
                  allCodici.push({
                    art_comp:opt,
                    qty:1});
                
                  p.opzioni.filter((o:any)=>o.codComp==opt).forEach((oo:any)=>{
                    if(oo.sezione=='OPZ PORTA MISURA LARG'){
                      misuraLarg=true;
                    }
                    if(oo.sezione=='OPZ PORTA MISURA ALT'){
                      misuraAlt=true;
                    }
                  });
                }
              });
              if(misuraAlt && misuraLarg){
                  allCodici.push({
                    art_comp:'M2064800',
                    qty:1});
              } 
              if(misuraLarg){
                allCodici.push({
                  art_comp:'M2065100',
                  qty:1});
              }
           

              // CODICI PORTE CONFIGURATE
              p.porte.forEach((codp:any)=>{
                if(p.tipologiaPorta=='STANDARD'){
                  allCodici.push({
                    art_comp:codp.codPorta2,
                    qty:1});
                } else {
                  allCodici.push({
                    art_comp:codp.CodPorta,
                    qty:1});
                }
                if(p.tipologiaPorta=='STANDARD' || p.tipologiaPorta=='SCORREVOLI' ){
                  if(p.conoblo){
                    allCodici.push({
                    art_comp:codp.codPannelloSIOblo,
                    qty:1});
                 
                  } else {
                    allCodici.push({
                    art_comp:codp.codPannelloNoOblo,
                    qty:1});
                   
                  }
                }
                if(p.tipologiaPorta=='INDUSTRIALI SCORREVOLI' || p.tipologiaPorta=='INDUSTRIALI BATTENTE' ){
                    allCodici.push({
                    art_comp:codp.codVersione,
                    qty:1});
                }
                if(p.tipologiaPorta=='INDUSTRIALI SCORREVOLI' ){
                    allCodici.push({
                    art_comp:codp.codCompletamento,
                    qty:1});
                }
              });
            }
  }

  elePorte(cellaDati:any,lato:string){
    return cellaDati.elencoPorte.filter((x:any)=>x.lato_porta==lato);
  }


  notLatoRaccPrec(ind:number,lato:string){
    let latoOpposto='';
    if(lato=='lato_retro'){
      latoOpposto='lato_fronte';
    }
    if(lato=='lato_fronte'){
      latoOpposto='lato_retro';
    }
    if(lato=='lato_ds'){
      latoOpposto='lato_sn';
    }
    if(lato=='lato_sn'){
      latoOpposto='lato_ds';
    }
    if(ind==0){
      return true;
    }
    if(this.configurazioneCelle.elencoCelle[ind-1].lato_raccordo==latoOpposto){
      return false;
    } else {
      return true;
    }
  }
  
  setLatoPorta(cellaDati:any,lato:any){
    if(lato=='lato_fronte'){
      cellaDati.lato_porta_lato_fronte=(cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_fronte').length>0);
    }
    if(lato=='lato_retro'){
      cellaDati.lato_porta_lato_retro=(cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_retro').length>0);
    }
    if(lato=='lato_sn'){
      cellaDati.lato_porta_lato_sn=(cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_sn').length>0);
    }
    if(lato=='lato_ds'){
      cellaDati.lato_porta_lato_ds=(cellaDati.elencoPorte.filter((x:any)=>x.lato_porta=='lato_ds').length>0);
    }
  }

  setLato(cellaDati:any,what:string,lato:string,ind:number){
    if(what=='porta'){
      this.modelService.addPorta(this.configurazioneCelle,cellaDati,lato,this.prev);
    
      if(cellaDati.lato_raccordo==lato){
        cellaDati.lato_raccordo='';
      }
   
    }
     if(what=='raccordo'){
     
      cellaDati.lato_raccordo=lato;
      if(ind<this.configurazioneCelle.elencoCelle.length-1){
        this.configurazioneCelle.elencoCelle[ind+1].lato_raccordo_prec=lato;
      }
    
    
      
    }
  }

  bordo(ind:number,lato:string){
    let latoOpposto='';
    if(lato=='lato_retro'){
      latoOpposto='lato_fronte';
      if(this.configurazioneCelle.elencoCelle[ind].lato_porta_lato_retro){
        return '5px solid Green';
      }
    }
    if(lato=='lato_fronte'){
      latoOpposto='lato_retro';
      if(this.configurazioneCelle.elencoCelle[ind].lato_porta_lato_fronte){
        return '5px solid Green';
      }
    }
    if(lato=='lato_ds'){
      latoOpposto='lato_sn';
      if(this.configurazioneCelle.elencoCelle[ind].lato_porta_lato_ds){
        return '5px solid Green';
      }
    }
    if(lato=='lato_sn'){

      latoOpposto='lato_ds';
      if(this.configurazioneCelle.elencoCelle[ind].lato_porta_lato_sn){
        return '5px solid Green';
      }
    
    }

   
    if(this.configurazioneCelle.elencoCelle[ind].lato_raccordo==lato){
      return '5px solid Yellow';
    }
    if(ind>0 && this.configurazioneCelle.elencoCelle[ind-1].lato_raccordo==latoOpposto){
      return '5px solid Gray';
    }
    return 'none';
  }
  

  
  printPdf(what='all'){
    this.drawCella();
    setTimeout(()=>{
      this.viewer.tavolaPdf(what,this.formatoStampa);
      this.showDialogPrint=false;
    },1000);
   
  }

  stampaTavole(){
    if(!this.checkFormIsValid()){
      return;
    }
    this.showDialogPrint=true;
  }
  
  exportPDF() {
      const doc = new jsPDF('portrait', 'px', 'a4');
      let dataxls= this.table.filteredValue
                  ? this.table.filteredValue
                  : this.modelService.distintaData;
      if(this.globalService.getUser().organization!='MISA' || this.globalService.getUser().role!='AMMINISTRATORE'){
        dataxls.forEach((d:any)=>{
          delete d.pzu_costo
        });
      }
      dataxls.forEach((d)=>{
        if(d.pzu_comp_uni){
          d.pzu_comp_uni=d.pzu_comp_uni.toFixed(2);
        }
         if(d.pzu_comp){
          d.pzu_comp=d.pzu_comp.toFixed(2);
        }
      });
      autoTable(doc, {
        columns:   this.colsDistinta.map(col => ({header: col.header, dataKey: col.field})) , 
        body: dataxls });
      doc.save(this.lang.el("distinta")+".pdf");
  }

  exportCSVCustom(table: any) {
    const separator = ';';
    const data = table.filteredValue ?? table.value;
    const columns = this.colsDistinta.filter(
      (c) => c.field === 'art_comp' || c.field === 'des_comp' || c.field === 'quantity'
    );
    const escape = (value: any) =>
      String(value ?? '').replace(/;/g, ',').replace(/\r?\n/g, ' ');
    const header = columns.map((c) => escape(c.header)).join(separator);
    const rows = data.map((row: any) =>
      columns.map((c) => escape(row[c.field])).join(separator)
    );
    const csv = '\ufeff' + [header, ...rows].join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = this.lang.el('distinta') + '.csv';
    link.click();
    URL.revokeObjectURL(link.href);
  }


  exportCSV(e:any){ 
    const hiddenColumns: any[] = [];
    e.columns.forEach((c:any) => {
      if (c.field != "art_comp" && c.field != "des_comp" && c.field != "quantity"  ) {
        hiddenColumns.push({field: c.field, col: c});
        c.field = '';
      }
      
    });
      
    e.exportCSV();
    // restore their fields so still works in the future
    hiddenColumns.forEach((hc:any) => {
      hc.col.field = hc.field;
    });
  }
  
  
  exportExcel() {

        let dataxls= this.table.filteredValue
                    ? this.table.filteredValue
                    : this.modelService.distintaData;
        if(this.globalService.getUser().organization!='MISA' || this.globalService.getUser().role!='AMMINISTRATORE'){
          dataxls.forEach((d:any)=>{
            delete d.pzu_costo
          });
        }
        import('xlsx').then((xlsx) => {

            const worksheet = xlsx.utils.json_to_sheet(
                this.table.filteredValue
                    ? this.table.filteredValue
                    : this.modelService.distintaData
            );
            const workbook = {
                Sheets: { data: worksheet },
                SheetNames: ['data'],
            };
            const excelBuffer: any = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array',
            });
            this.modelService.saveAsExcelFile(excelBuffer, 'distinta');
        });
  }

  

  onChangeGeometria(event:any){
    this.configurazioneCelle.numeroCelle=1;
    this.onChangeNumeroCelle(null);
  }

  

  onChangeNumeroCelle(event:any){

    if(this.configurazioneCelle.numeroCelle<this.configurazioneCelle.elencoCelle.length){
      for(let j=this.configurazioneCelle.numeroCelle;j<this.configurazioneCelle.elencoCelle.length;j++){
        this.configurazioneCelle.elencoCelle.splice(j,1);
      }
    }
    if(this.configurazioneCelle.numeroCelle>this.configurazioneCelle.elencoCelle.length){
      for(let j=this.configurazioneCelle.elencoCelle.length;j<this.configurazioneCelle.numeroCelle;j++){
        let c=this.modelService.initCella(this.opzioniList,this.prev.lang,this.prev.electrolux);
        this.modelService.changeDescTecnica(c,this.prev.lang);
        this.configurazioneCelle.elencoCelle.push(c);
      }
    }
   
  }
  eliminaPorta(cellaDati:any){
    cellaDati.elencoPorte.splice(cellaDati.elencoPorte.length-1,1);
    this.setLatoPorta(cellaDati,'lato_fronte');
    this.setLatoPorta(cellaDati,'lato_retro');
    this.setLatoPorta(cellaDati,'lato_sn');
    this.setLatoPorta(cellaDati,'lato_ds');
    

    
  }


  apriOpzioni(cellaDati:any,ind:number){
   
   this.selectedCella={};

    this.selectedCella.numeroCella=ind;
    this.selectedCella.opzioni=this.configurazioneCelle.elencoCelle[this.selectedCella.numeroCella].opzioni;

    this.showOpzioni=true;
  }

  setPrezzo(valore:any){
    if(valore){
      return  parseFloat(valore);
    }
    return '';
  }

  aggiornaDistinta(tutteLeCelle=false){

    
    if(this.selectedCella ){
      this.configurazioneCelle.elencoCelle[this.selectedCella.numeroCella].opzioni=this.selectedCella.opzioni;

    }

    var i = this.modelService.distintaData.length;
    while (i--) {
      if(this.modelService.distintaData[i].opzione){
        this.modelService.distintaData.splice(i,1);
      }
    }
   
    let codiceCappelloMistral='';
    this.modelService.distintaData.forEach((cod:any)=>{
      if(cod.codicePadre.indexOf('MISTRAL')>=0){
        codiceCappelloMistral=cod.codicePadre;
      }
    });
    this.configurazioneCelle.elencoCelle.forEach((c:any,ind:number)=>{
      if(c.opzioni){
        c.opzioni.forEach((selx:any)=>{
          if(selx.qty>0){
            let prezzo=0;
            if(selx.pzu_comp){
              prezzo= parseFloat(selx.pzu_comp);
            }
            let isPresent=false;
            this.modelService.distintaData.forEach((d:any,indd:number)=>{
              if(d.art_comp==selx.art_comp){
                isPresent=true;
                this.modelService.distintaData[indd].quantity+=selx.qty;
                this.modelService.distintaData[indd].pzu_comp+=selx.qty*prezzo;
              }
            });
            if(!isPresent){
              if(codiceCappelloMistral!=''){
                this.modelService.distintaData.push({
                  codicePadre:codiceCappelloMistral,
                  art_comp:selx.art_comp,
                  des_comp:selx.descrizione_opzione_cella,
                  quantity:selx.qty,
                  pzu_comp:prezzo*selx.qty,
                  pzu_comp_uni:prezzo,
                  originalQuantity:selx.qty,
                  active:true,
                  opzione:true
                })    
              }
              if(!this.modelService.userCellePreConf())
              this.modelService.distintaData.push({
                codicePadre:'XMISAACC',
                art_comp:selx.art_comp,
                des_comp:selx.descrizione_opzione_cella,
                quantity:selx.qty,
                pzu_comp:prezzo*selx.qty,
                pzu_comp_uni:prezzo,
                originalQuantity:selx.qty,
                active:true,
                opzione:true
              })
            }
       
          }
        })
      }
    });
  
    this.modelService.distintaData=[...this.modelService.distintaData];
  
    this.refreshDistinta();
    this.selectedCella=null;
    this.showOpzioni=false;
  }

  caricaCliente(){
    if(this.prev.account_id){
      this.clientiList.forEach((x)=>{
        if(x.value==this.prev.account_id){
          if(x.label){
                this.prev.ragSoc=x.label;
          }
        }
      });
    } else {
      this.prev.ragSoc='';
    }
  }

  creaOfferta2(archivia:boolean){
    let urldoc='';
    this.doctemplatesList.forEach((d:any)=>{
      if(d.value==this.prev.doctemplate){
        urldoc=d.filename;
      }
    });
    let celle:any=[];
  let totale=0;
  let tb:any=[];
  //nome_opportunita
  //author
  let eleCelleId:any[]=[];
  this.prev.celle.forEach((c:any,ind:number)=>{
    eleCelleId.push(c.id);
    let objC:any={};
    objC.descrizioneTecnica='';
    objC.dim='';
    objC.porte=[];
    let objCaratt:any=[];
    let elencoCelle:any=null;
      if (typeof c.elencoCelle === 'string' || c.elencoCelle instanceof String){
      elencoCelle=JSON.parse(c.elencoCelle);
      } else {
      elencoCelle=c.elencoCelle;
      } 
      let codice='';
      elencoCelle.forEach((cella:any,ind:number)=>{ 
        codice='';

        if(c.distinta){
          let distinta=JSON.parse(c.distinta);
          distinta.forEach((row:any)=>{
            codice=row.codicePadre;
          });
        }

        objC.dim=(cella.ingombroX+3)*10+'x'+(cella.ingombroY+3)*10+'x'+(cella.altezza+3)*10;
        objC.vol=((cella.ingombroX+3)*(cella.ingombroY+3)*(cella.altezza+3)/1000000).toFixed(2)+'m^3';
        if(cella.pavimenti){
          objC.pav=this.lang.el(' con pavimento ');
          objC.pav+=cella.finituraPavimento;
        } else {
          objC.pav=this.lang.el(' senza pavimento ');
        }

        if(cella.descrizioneTecnica){
          cella.desc = cella.descrizioneTecnica.replace(/[\n\r]/g, '\n');
          objC.desc=cella.descrizioneTecnica;
        } 
        
        cella.elencoPorte.forEach((p:any)=>{
          let verso='';
          if(p.versoAperturaPorta==1){
            verso='Sx';
          }
          if(p.versoAperturaPorta==2){
            verso='DX';
          }
          if(p.versoAperturaPorta==-1){
            verso=''; // lo vado a prendere dalla descrizione della porta
          }
          let ln='';
          if(p.luceNetta){
            ln=p.luceNetta.replaceAll('0x','00x').replaceAll('0h','00h');
          }
          let tp=p.tipoPorta;
          if(p.tipoPorta=='STANDARD'){
            tp=this.lang.el('Battente commerciale');
          }
          if(p.tipoPorta=='SCORREVOLI'){
            tp=this.lang.el('Scorrevole commerciale');
          }
          if(p.tipoPorta=='INDUSTRIALI SCORREVOLI'){
            tp=this.lang.el('Industriale scorrevole');
          }
          if(p.tipoPorta=='INDUSTRIALI BATTENTE'){
            tp=this.lang.el('Industriale battente');
          }
      
          // luce netta in mm
          
        
          objC.porte.push({
            pmod:this.lang.el('Porta')+ ' '+tp,
            luce:ln,
            tipoape:verso
          });
        });
      });

      
      if(c.descrizione){
        objC.nomecella=c.descrizione;
      } else {
          objC.nomecella='';
      }
      if(c.prezzo){
        objC.prezzo=parseFloat(c.prezzo).toFixed(2).toLocaleString();
        totale+=parseFloat(c.prezzo);
      } else {
        objC.prezzo=parseFloat("0").toFixed(2).toLocaleString();
      }
      objC.prezzoun=objC.prezzo;
      objC.qty=1;
      objC.codice=codice;
      celle.push(objC);
    });

    if(!this.prev.exp_closing_date){
      this.prev.exp_closing_date=new Date();
    }
    if(!this.prev.dataRes){
      this.prev.dataRes=new Date();
    }


    let ragSoc='';
    if(this.prev.accountName){
      ragSoc=this.prev.accountName;
    } else{
      this.clientiList.forEach((x)=>{
        if(x.id==this.prev.account_id){
          if(x.name){
                ragSoc=x.name;
          }
        }
      });
    } 

    if(false && this.modelService.userCellePreConf()){
      celle=[];
      let cella:any=[];
      this.prev.celle.forEach((c:any,ind:number)=>{
        cella=[];
        if(c.distinta){
          let distinta=JSON.parse(c.distinta);
          distinta.forEach((row:any)=>{
            let desc=row.des_comp;
            if(row.extra){
              desc+='\n'+row.extra;
            }
            cella.push({
              art_comp:row.art_comp,
              desc:desc,
              qty:row.quantity,
              prezzo:row.pzu_comp,
              prezzoun:row.pzu_comp_uni
            });
          });
          celle.push(cella);
        }
        });

    }
   
    let params={
      prev_id:this.prev.id,
      templatepath:urldoc,
      eleCelleId:eleCelleId,
      fields:{
        attNe:this.prev.attNe? this.prev.attNe :'',
        totale:totale.toLocaleString(),
        author:this.globalService.getUser().name+' '+this.globalService.getUser().surname,
        nPrev:this.prev.id? this.prev.id :'',
        nome_opportunita:this.prev.name,
        nP2:this.prev.num_opp? this.prev.num_opp :'',
        ragSoc:(ragSoc === undefined)? '':ragSoc,
        indCli:this.prev.indCli? this.prev.indCli :'',
        dataPrev:formatDate(this.prev.exp_closing_date,'dd/MM/yyyy',this.locale),
        resa:this.prev.resa? this.prev.resa :'',
        tempoProduzione:this.prev.tempoProduzione? this.prev.tempoProduzione :'',
        validitaOfferta:this.prev.validitaOfferta? this.prev.validitaOfferta :'',
        condizioniPagamento:this.prev.condizioniPagamento ? this.prev.condizioniPagamento :'',
      },
      celle: celle
    };
    this.apiService.post('app/printofferta',params).subscribe(data2 => {
     window.open(
        this.globalService.endpointdocs+data2.Result['offerta'],
        '_blank' 
      );
    });
  
  }
  
  creaOfferta(archivia:boolean){
    let urldoc=this.globalService.endpoint+'../docstemplates/';
  
    this.doctemplatesList.forEach((d:any)=>{
      if(d.value==this.prev.doctemplate){
        urldoc+=d.filename;
      }
    });
  
    loadFile(
      urldoc,
       (error: Error | null, content: string)=> {
        if (error) {
          throw error;
        }
        let css= `
                th {
                  background-color:Gray;
                }
            `;
        const zip = new PizZip(content);
        const doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true,
        });
        
        let celle:any=[];
        let totale=0;
        let tb:any=[];
        //nome_opportunita
        //author

        this.prev.celle.forEach((c:any,ind:number)=>{
          let objC:any={};
          objC.descrizioneTecnica='';
          objC.dim='';
          objC.porte=[];
          let objCaratt:any=[];
          let elencoCelle:any=null;
           if (typeof c.elencoCelle === 'string' || c.elencoCelle instanceof String){
            elencoCelle=JSON.parse(c.elencoCelle);
           } else {
            elencoCelle=c.elencoCelle;
           } 

          elencoCelle.forEach((cella:any,ind:number)=>{ 
            objC.dim=(cella.ingombroX+3)*10+'x'+(cella.ingombroY+3)*10+'x'+(cella.altezza+3)*10;
            objC.vol=((cella.ingombroX+3)*(cella.ingombroY+3)*(cella.altezza+3)/1000000).toFixed(2)+'m^3';
            if(cella.pavimenti){
              objC.pav=this.lang.el(' con pavimento ');
              objC.pav+=cella.finituraPavimento;
            } else {
              objC.pav=this.lang.el(' senza pavimento ');
            }

            if(cella.descrizioneTecnica){
              cella.desc = cella.descrizioneTecnica.replace(/[\n\r]/g, '\n');
              objC.desc=cella.descrizioneTecnica;
            } 
            
            cella.elencoPorte.forEach((p:any)=>{
              let verso='';
              if(p.versoAperturaPorta==1){
                verso='Sx';
              }
              if(p.versoAperturaPorta==2){
                verso='DX';
              }
              if(p.versoAperturaPorta==-1){
                verso=''; // lo vado a prendere dalla descrizione della porta
              }
              let ln='';
              if(p.luceNetta){
                ln=p.luceNetta.replaceAll('0x','00x').replaceAll('0h','00h');
              }
              let tp=p.tipoPorta;
              if(p.tipoPorta=='STANDARD'){
                tp=this.lang.el('Battente commerciale');
              }
              if(p.tipoPorta=='SCORREVOLI'){
                tp=this.lang.el('Scorrevole commerciale');
              }
              if(p.tipoPorta=='INDUSTRIALI SCORREVOLI'){
                tp=this.lang.el('Industriale scorrevole');
              }
              if(p.tipoPorta=='INDUSTRIALI BATTENTE'){
                tp=this.lang.el('Industriale battente');
              }
          
              // luce netta in mm
              
           
              objC.porte.push({
                pmod:this.lang.el('Porta')+ ' '+tp,
                luce:ln,
                tipoape:verso
              });
            });
          });

          
          if(c.descrizione){
            objC.nomecella=c.descrizione;
          } else {
             objC.nomecella='';
          }
          if(c.prezzo){
            objC.prezzo=parseFloat(c.prezzo).toFixed(2).toLocaleString();
            totale+=parseFloat(c.prezzo);
          } else {
            objC.prezzo=parseFloat("0").toFixed(2).toLocaleString();
          }
          objC.prezzoun=objC.prezzo;
          objC.qty=1;
          celle.push(objC);
        });

        if(!this.prev.exp_closing_date){
          this.prev.exp_closing_date=new Date();
        }
        if(!this.prev.dataRes){
          this.prev.dataRes=new Date();
        }


        let ragSoc='';
        if(this.prev.accountName){
          ragSoc=this.prev.accountName;
        } else{
          this.clientiList.forEach((x)=>{
            if(x.id==this.prev.account_id){
              if(x.name){
                    ragSoc=x.name;
              }
           
            }
          });
         
        } 
      
        if(this.modelService.userCellePreConf()){
          celle=[];
          this.prev.celle.forEach((c:any,ind:number)=>{
            if(c.distinta){
              let distinta=JSON.parse(c.distinta);
              distinta.forEach((row:any)=>{
                let desc=row.des_comp;
                if(row.extra){
                  desc+='\n'+row.extra;
                }
                celle.push({
                  art_comp:row.art_comp,
                  desc:desc,
                  qty:row.quantity,
                  prezzo:row.pzu_comp,
                  prezzoun:row.pzu_comp_uni
                });
              })
            }
           });

        }
        doc.render({
          attNe:this.prev.attNe? this.prev.attNe :'',
          totale:totale.toLocaleString(),
          author:this.globalService.getUser().name+' '+this.globalService.getUser().surname,
          nPrev:this.prev.id? this.prev.id :'',
          nome_opportunita:this.prev.name,
          nP2:this.prev.num_opp? this.prev.num_opp :'',
          ragSoc:(ragSoc === undefined)? '':ragSoc,
          indCli:this.prev.indCli? this.prev.indCli :'',
          dataPrev:formatDate(this.prev.exp_closing_date,'dd/MM/yyyy',this.locale),
          resa:this.prev.resa? this.prev.resa :'',
          tempoProduzione:this.prev.tempoProduzione? this.prev.tempoProduzione :'',
          validitaOfferta:this.prev.validitaOfferta? this.prev.validitaOfferta :'',
          condizioniPagamento:this.prev.condizioniPagamento ? this.prev.condizioniPagamento :'',
          celle: celle
        });


        const out = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        });
        // Output the document using Data-URI
        saveAs(out, this.prev.id+'.docx');
      });
  }

  printTavole(archivia:boolean){
    this.printPdf(this.tipoStampa);
  }

  changePrezzo(config:any){
    if(!config.prezzolordo){
      config.prezzo=null;
    }
    if(config.sconto){
      config.prezzo=(config.prezzolordo-config.prezzolordo*config.sconto/100).toFixed(2);
    } else {
      config.prezzo=config.prezzolordo;
    }
    
  }

  getPrezzoTotale(){
    let prezzo=0;
    this.prev.celle.forEach((p:any)=>{
      prezzo+=parseFloat(p.prezzo);
    })
    return prezzo;

  }

  getPrezzoTotaleListino(){
    let prezzo=0;
    this.prev.celle.forEach((p:any)=>{
      prezzo+=parseFloat(p.prezzolordo);
    })
    return prezzo;

  }

  eliminaDoc(record:any,index:number){

    this.confirmationService.confirm({
        message: this.lang.el('Si conferma la cancellazione del documento?'),
        header: this.lang.el('Conferma'),
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:this.lang.el('Annulla'),
        acceptLabel:this.lang.el('Conferma'),
        accept: () => {
      
          this.apiService.post('app/doc_delete',{id:record.id}).subscribe(data2 => {
            this.messageService.add({ severity: 'warning', summary:  this.lang.el('Eliminato'), 
              detail:  this.lang.el('Record cancellato') });
            this.loadDocs();
          });
          
        },
        reject: () => {
           
        },
    });
 
  }
  downloadDoc(record:any){
    window.open(this.globalService.endpointdocs+record.filename);

  }
 
  
  caricaDocDialog(){
    
    this.newDoc={
      id:null,
      tipo:'Offerta',
      descrizione:''
    };
    this.showDocs=true;
  }

  salvaDoc(){
     this.newDoc['loggedUser']=this.globalService.getUser().id;
    this.apiService.post('app/doc_update',this.newDoc).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      this.loadDocs();
        this.showDocs=false;
    });

   
  }

  
  onBeforeSend(event:any) {
       event.xhr.setRequestHeader("Authorization", `Bearer ${this.globalService.getToken()}`);
  }
  
  onUpload(event:any){
   
    this.newDoc.id=event.originalEvent.body[0];
 
  }

  

  loadDocs(){
    this.apiService.post('app/docs_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.docsList=data2.Result;
        this.loadingDocs=false;
      });
  }

  salvaSconto(record:any){
    
 
    this.configurazioneCelle=record; 
    if(this.configurazioneCelle.distinta){
      this.configurazioneCelle.distinta=JSON.parse(this.configurazioneCelle.distinta);
    }
    if (typeof record.elencoCelle === 'string' || record.elencoCelle instanceof String){
      this.configurazioneCelle.elencoCelle=JSON.parse(record.elencoCelle);
    } else {
      this.configurazioneCelle.elencoCelle=record.elencoCelle;
    }
   
    this.changePrezzo(this.configurazioneCelle);
    
    this.saveCella(false,false,false);
    //this.drawCella();

  }

  deleteComponenteAggiunto(record:any){
    this.modelService.distintaData=this.modelService.distintaData.filter((x:any)=>x.art_comp!=record.art_comp);
    this.refreshDistinta();
  }

  resetDistinta(){
      this.confirmationService.confirm({
        message: this.lang.el('Le modifiche alla distinta verranno annullate. Si confeorma?'),
        header: this.lang.el('Conferma'),
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:this.lang.el('Annulla'),
        acceptLabel:this.lang.el('Conferma'),
        accept: () => {
      
            this.modelService.resetDistinta(this.configurazioneCelle);
        },
        reject: () => {
           
        },
    });
 
  }

  refreshDistinta(record:any=null){
    if(record){
        record.new='x';
    }
   
    

    let prezzo=0;
    let prezzoDagard=0;
    this.modelService.distintaData.forEach((d:any,ind:number)=>{
        prezzo+=d.quantity*d.pzu_comp_uni;
        this.modelService.distintaData[ind].pzu_comp=d.quantity*d.pzu_comp_uni;
        if(d.codicePadre.indexOf('MISTRAL')>=0){
            prezzoDagard+=d.quantity*d.pzu_comp_uni;
        }
    });

    this.configurazioneCelle.prezzolordo=prezzoDagard>0 ? prezzoDagard: prezzo;
    this.changePrezzo(this.configurazioneCelle);
  }


  
  openDialogComp(){
    this.componentList=[];
    this.gruppoDistintaList=[];
    this.gruppoDistinta=null;
    this.modelService.distintaData.forEach((x:any)=>{
      if(!this.gruppoDistintaList.includes(x.codicePadre)){
        this.gruppoDistintaList.push(x.codicePadre);
        this.gruppoDistinta=this.gruppoDistintaList[0];
      }
    });
    this.showDialogAddComp=true;
    this.compToAdd=null;
    this.qtyToAdd=1;
  }
  
  
  openDialogRiga(){
    this.componentList=[];
    this.gruppoDistintaList=[];
    this.gruppoDistinta=null;
    this.modelService.distintaData.forEach((x:any)=>{
      if(!this.gruppoDistintaList.includes(x.codicePadre)){
        this.gruppoDistintaList.push(x.codicePadre);
        this.gruppoDistinta=this.gruppoDistintaList[0];
      }
    });
    this.riga={
      art_comp:'',
      des_comp:'',
      pzu_comp_uni:0,
      quantity:1
    };
    this.showDialogAddRiga=true;
    this.compToAdd=null;
  }

  addRigaToDistinta(){
    
    this.riga['new']='x';
    this.riga['active']=true;
    this.riga['pzu_comp']=this.riga['quantity']*this.riga['pzu_comp_uni'];
    this.riga['codicePadre']=this.gruppoDistinta;
    this.modelService.distintaData.push(this.riga);
    this.showDialogAddRiga=false;
    this.modelService.distintaData=[...this.modelService.distintaData];
    this.refreshDistinta();
  }

  addCompToDistinta(){
    let res= this.componentList.filter((x:any)=>x.art_comp===this.compToAdd);
    res[0].quantity=this.qtyToAdd;
    res[0].originalQuantity=this.qtyToAdd;
    res[0].new='x';
    res[0].active=true;
    res[0].codicePadre=this.gruppoDistinta;
   
    let found=false;
    this.modelService.distintaData.forEach((c:any,ind:number)=>{
      if(c.art_comp==this.compToAdd){
        found=true;
        this.modelService.distintaData[ind].quantity+=this.qtyToAdd;
      }
    });
    if(!found){
       this.modelService.distintaData.push(res[0]);
    }
    this.modelService.distintaData=[...this.modelService.distintaData];
    this.showDialogAddComp=false;
    this.refreshDistinta();
  }
  
  searchComp(){
    this.loadingComponentList=true;
    this.componentList=[];
    let params:any={
      compSearchCode:this.compSearchCode,
      compSearchDesc:this.compSearchDesc
    }
    params.isDagard=false;
    if(window.location.hostname.indexOf('dagard')>=0){
      params.isDagard=true;
    }

    this.apiService.post('app/searchcomp',params).subscribe(data2 => {
      this.componentList=data2.Result;
      this.loadingComponentList=false;
    });

  }

  
  
  duplicaCella(record:any){
    this.apiService.post('app/opportunity_duplicacella',{opp_id:this.route.snapshot.paramMap.get('id'),id:record.id,loggedUser:this.globalService.getUser().id}).subscribe(data2 => {
      this.apiService.post('app/opportunities_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
          this.prev=data2.Result[0];
       
      });
    });
  }

  tabOnChange(event:any){
   
   if(event.index==5){
    setTimeout(()=>{
   
   //   this.modelService.diagram.zoomTo((0.3/this.modelService.diagram.scrollSettings.currentZoom)-1);
    },500);
   }
   /*
   if(event.index==4){
      this.changePrezzo(this.configurazioneCelle);
      this.drawCella();
      this.message='';
    
   }
   */
  }

  messageEvent(obj:any){
    
    if(obj.what=='draw3DNoRefresh'){
      this.drawCella(false);
    }
    if(obj.what=='draw3D'){
      this.drawCella();
    }
    if(obj.what=='draw3DandSave'){
      this.modelService.isSaving=true;
      // salva SOLO a distinta ricalcolata (niente timeout fisso: evitava salvataggi con totale vecchio)
      this.drawCella(true, () => {
        if (!this.modelService.distintaData || this.modelService.distintaData.length === 0) {
          this.modelService.isSaving = false;
          this.addSingle('error', this.lang.el('Errore'), this.lang.el('Distinta vuota: salvataggio annullato'));
          return;
        }
        this.configurazioneCelle['logged_user_id']=this.globalService.getUser().id;
        this.configurazioneCelle.opp_id=this.prev.id;
        this.configurazioneCelle.distinta=this.modelService.distintaData;
        let params={
          rigaCella:this.configurazioneCelle
        }
        this.apiService.post('app/opportunity_cella_update2',params).subscribe({
          next: (data) => {
            this.addSingle('success', this.lang.el('Successo'), this.lang.el('Configurazione salvata'));
            this.modeldesign.tipoStampa='pareti';
            this.modeldesign.formatoStampa='A4';
            this.modeldesign.creaPDF2('PDF',data.Result);
          },
          error: () => {
            this.modelService.isSaving = false;
            this.addSingle('error', this.lang.el('Errore'), this.lang.el('Salvataggio non riuscito'));
          }
        });
      });
    }

    if(obj.what=='apriOpzioni'){
      this.apriOpzioni(obj.cellaDati,obj.ind);
    }
  }
  
  

}
